module.exports = __webpack_public_path__ + "static/media/Contract.881fd6dd.svg";